import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [{
    path: '/siteindex',
    name: 'siteindex',
    component: () => import('@/views/website/index/siteindex.vue'),
    alias: 'siteindex',
    meta: {
      title: '静哲个人中心'
    },
    children: [{
        path: '/smindex',
        name: 'smindex',
        component: () => import('@/views/website/index/smindex.vue'),
        alias: 'smindex',
        meta: {
          parentName: 'siteindex',
          title: "首页"
        }
      },
      {
        path: '/appindex',
        name: 'appindex',
        component: () => import('@/views/website/app/appindex.vue'),
        alias: 'appindex',
        meta: {
          parentName: 'siteindex',
          title: "app项目列表"
        }
      }, {
        path: '/minindex',
        name: 'minindex',
        component: () => import('@/views/website/minip/minindex.vue'),
        alias: 'minindex',
        meta: {
          parentName: 'siteindex',
          title: "小程序项目列表"
        }
      }, {
        path: '/other',
        name: 'other',
        component: () => import('@/views/website/other/other.vue'),
        alias: 'other',
        meta: {
          parentName: 'siteindex',
          title: "占位页面"
        }
      }, {
        path: '/about',
        name: 'about',
        component: () => import('@/views/website/personal/about.vue'),
        alias: 'about',
        meta: {
          parentName: 'siteindex',
          title: "关于我们"
        }
      }
    ]
  }, {
    path: '/appdetail',
    name: 'appdetail',
    component: () => import('@/views/website/app/appdetail.vue'),
    alias: 'appdetail',
    meta: {
      title: 'app详情'
    }
  }, {
    path: '/minidetail',
    name: 'minidetail',
    component: () => import('@/views/website/minip/minidetail.vue'),
    alias: 'minidetail',
    meta: {
      title: '小程序详情'
    }
  }, {
    path: '/webh5',
    name: 'webh5',
    component: () => import('@/views/website/web/webh5.vue'),
    alias: 'webh5',
    meta: {
      title: '网站详情'
    }
  }, {
    path: '/mcounter',
    name: 'mcounter',
    component: () => import('@/views/mcu/mcounter.vue'),
    alias: 'mcounter',
    meta: {
      title: '计数器'
    }
  }, {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/llogin.vue'),
    meta: {
      title: "登录"
    }
  }, {
    path: '/grid',
    name: 'grid',
    component: () => import('@/views/headend/bills/grid.vue'),
    meta: {
      title: "单据打印"
    }
  }, {
    path: '/mindex',
    name: 'mindex',
    component: () => import('@/views/main/mindex.vue'),
    meta: {
      title: "首页",
      icon: ""
    },
    children: [{
      path: "/mainIndex",
      name: "mainIndex",
      meta: {
        title: "首页",
      }
    }, {
      path: '/projectlist',
      name: 'projectlist',
      component: () => import('@/views/projectmanage/project/ProjectList.vue'),
      alias: 'projectlist',
      meta: {
        parentName: 'mindex',
        title: "项目信息"
      }
    }, {
      path: '/changelist',
      name: 'changelist',
      component: () => import('@/views/projectmanage/change/ChangeList.vue'),
      alias: 'changelist',
      meta: {
        parentName: 'mindex',
        title: "变更清单"
      }
    }, {
      path: '/changelist',
      name: 'changelist',
      component: () => import('@/views/projectmanage/change/ChangeList.vue'),
      alias: 'changelist',
      meta: {
        parentName: 'mindex',
        title: "变更管理"
      }
    }, {
      path: '/developlist',
      name: 'developlist',
      component: () => import('@/views/projectmanage/develop/DevelopList.vue'),
      alias: 'developlist',
      meta: {
        parentName: 'mindex',
        title: "开发管理"
      }
    }, {
      path: '/tasklist',
      name: 'tasklist',
      component: () => import('@/views/learnmanage/dailytask/TaskList.vue'),
      alias: 'tasklist',
      meta: {
        parentName: 'mindex',
        title: "任务管理"
      }
    }, {
      path: '/productlist',
      name: 'productlist',
      component: () => import('@/views/learnmanage/product/ProductList.vue'),
      alias: 'productlist',
      meta: {
        parentName: 'mindex',
        title: "产品库"
      }
    }, {
      path: '/questionlist',
      name: 'questionlist',
      component: () => import('@/views/learnmanage/question/QuestionList.vue'),
      alias: 'questionlist',
      meta: {
        parentName: 'mindex',
        title: "问题库"
      }
    }, {
      path: '/experiencelist',
      name: 'experiencelist',
      component: () => import('@/views/learnmanage/experience/ExperienceList.vue'),
      alias: 'experiencelist',
      meta: {
        parentName: 'mindex',
        title: "经验库"
      }
    }, {
      path: '/articlelist',
      name: 'articlelist',
      component: () => import('@/views/learnmanage/article/ArticleList.vue'),
      alias: 'articlelist',
      meta: {
        parentName: 'mindex',
        title: "文章列表"
      }
    }, {
      path: '/rolelist',
      name: 'rolelist',
      component: () => import('@/views/system/role/RoleList.vue'),
      alias: 'rolelist',
      meta: {
        parentName: 'mindex',
        title: "角色信息"
      }
    }, {
      path: '/userlist',
      name: 'userlist',
      component: () => import('@/views/system/user/UserList.vue'),
      alias: 'userlist',
      meta: {
        parentName: 'mindex',
        title: "用户信息"
      }
    }, {
      path: '/richtest',
      name: 'richtest',
      component: () => import('@/views/element/test/richtest.vue'),
      alias: 'richtest',
      meta: {
        parentName: 'mindex',
        title: "富文本"
      }
    }]
  }]
});

const whiteList = ['/login', '/siteindex', '/smindex', '/appindex', '/minindex', '/other', '/about', '/coer',
  '/appdetail', '/minidetail', '/webh5', '/mcounter'
];
router.beforeEach(async (to, from, next) => {
  /*
  if (store.getters.token || to.path.includes("/login")
      || to.path.includes("/grid")) {
      next();
  } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
  }*/
  if (to.path == '/') {
    next(`/login?redirect=${to.path}`)
  } else if (whiteList.includes(to.path)) {
    if (to.path.includes('siteindex')) {
      next(`/smindex?redirect=${to.path}`)
    } else {
      next();
    }
  } else {
    if (store.getters.token) {
      next();
    } else {
      next(`/login?redirect=${to.path}`)
    }
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js